import React from "react";

const ScenarioHeading = () => (
  <>
    <h1 className="quiz-title mb-2">
      What would you do if you came across this post?
    </h1>
    <p className="quiz-subtitle mb-5">
      🔎 Information can be deeply misleading—always verify emotional or
      surprising claims using trusted and reliable sources.
    </p>
  </>
);

export default ScenarioHeading;
